import React from 'react'
import { modal, ModalParams } from '@codeleap/modals'
import { ActionIcon, Button, Pager, Tag, Text, View } from '@/components'
import { usePager } from '@/utils'
import { LessonPaginationIndicator } from '../../LessonPaginationIndicator'
import { AppImages, variantProvider } from '@/app'
import { APIClient } from '@/services'
import { PersonaUtils } from '../../utils'
import { useAnswerProfile } from './useAnswerProfile'
import { ProfilePrompt } from '@/types'
import { questions } from './questions'
import { OnboardingSuccessModal } from '../OnboardingSuccessModal'

function Content(props: ModalParams) {
  const { toggle, visible } = props

  const missingAnswers = React.useMemo(PersonaUtils.getMissingAnswers, [visible])
  const query = APIClient.Community.profileQuestionsManager.useList({ filters: { including_keys: missingAnswers }})
  const pages = query.items || []

  const onFinish = React.useCallback(() => {
    toggle()
    OnboardingSuccessModal.toggle()
  }, [toggle])

  const pager = usePager({ pages, onFinish })

  const prompt = useAnswerProfile({ onSuccess: pager.next })

  const renderItem = React.useCallback(
    (item: ProfilePrompt) => {
      const { title, description, image, key: questionKey } = item

      const isAnswered = prompt.isAnswered(questionKey)

      const Question = questions[questionKey]

      console.log({ questionKey, isAnswered, values: prompt.form.values, Question, form: prompt.form })

      return (
        <>
          <View style={styles.header}>
            <View variants={['column', 'fullWidth', 'gap:1']}>
              <LessonPaginationIndicator pages={pages.length + 1} currentPage={pager.page + 1} />
              <View variants={['row', 'justifySpaceBetween', 'fullWidth']}>
                <Tag text='Build your learning journey' css={{ backgroundColor: '#E0DFDFBF' }} variants={['paddingVertical:0.5']} />
                <ActionIcon name='x' variants={['outline']} onPress={toggle} />
              </View>
            </View>
            {image ? <View style={[styles.image, { backgroundImage: `url(${image})` }]} /> : null}
          </View>

          <View variants={['gap:1', 'fullWidth', 'column', 'padding:3', 'fullHeight']} >
            <Text variants={['h1']} text={title} />
            <Text variants={['h2', 'color:neutral5']} text={description} />
            <View variants={['fullWidth', 'column']} style={{ minHeight: 230 }}>
              <Question form={prompt.form} disabled={isAnswered} />
            </View>
            <Button text={'Submit'} onPress={() => prompt.onUpdate(questionKey)} disabled={isAnswered} />
          </View>
        </>
      )
    },
    [pages.length, pager.page, prompt.form.values, prompt.form],
  )

  if (query.query.isLoading) return null //TODO: Loading State
  return (
    <Pager pagerRef={pager.ref} debugName='LearnOnboardingModal:Pager' page={pager.page} onChange={pager.setPage} disableSwipe>
      {pages.map(renderItem)}
    </Pager>
  )
}

const styles = variantProvider.createComponentStyle(
  t => ({
    header: {
      ...t.presets.fullWidth,
      height: 300,
      backgroundImage: `url(${AppImages.appBlueBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      ...t.spacing.padding(3),
      ...t.presets.column,
      ...t.spacing.gap(3),
    },
    image: {
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  }),
  true,
)

export const LearnOnboadingModal = modal()
  .content(props => <Content {...props} />)
  .props({
    variants: ['noPadding', 'width:700'],
    closable: false,
  })
